<script>
import common from './common.vue';
export default {
  mixins: [common],
  data() {
    return {
      fanhuiIcon: `${this.$cdnLink}/wanXin/yssl/back1.png`,
    }
  }
};
</script>

<style lang="scss" module>
@import "../../../assets/css/yssl.scss";

.wrap {
  @include common-window();
  z-index: 100;
  > header {
    position: relative;

    .fanhui {
      position: absolute;
      top: 0.45rem;
      left: 0.46rem;
      width: .35rem;
      height: .3rem;
    }
  }
  > main {
    padding: 0.38rem 0.24rem;
    overflow-y: auto;
  }
  > iframe {
    width: 80%;
    background-color: #FFFFFF;
    height: calc(100% - 2.23rem);
    display: block;
    margin: auto;
    margin-top: .2rem;
    box-sizing: border-box;
    border-radius: .05rem;
  }
  &.fullScreen {
    @include full-screen-window();
    > header {
      position: relative;
      > span {
        font-weight: 600;
      }
      .fanhui {
        position: absolute;
        top: 36px;
        right: 13px;
        width: 29px;
        height: 30px;
      }
    }
    > main {
      padding: 19px 12px;
      overflow-x: hidden;
      overflow-y: auto;
    }
    > iframe {
      width: 80%;
      background-color: #FFFFFF;
      height: calc(100% - 111px);
      display: block;
      margin: auto;
      margin-top: 10px;
      box-sizing: border-box;
      border-radius: 2.5px;
    }
  }
}
</style>